// 运行环境开关：true=仅微信环境；false=普通浏览器（可用手机号+密码+占位 openId 登录）
export const IS_WECHAT_ENV = process.env.NODE_ENV === "production";

// 服务电话（唯一来源）：About 页与登录页共用，以后换号只改这一处
export const SERVICE_PHONES = ["18663898913", "18865599628", "13854516201"];
